import React from 'react';
import { Box } from '@mui/material';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { es as esLocale } from 'date-fns/locale';
import { isValid } from 'date-fns';

export interface CommercialDateTimePickerProps {
  label: string;
  value: Date;
  onChange: (value: Date) => void;
  disabled?: boolean;
}

/**
 * Shared commercial date/time picker used by Nueva Venta and Procesar Pago.
 * Self-contained LocalizationProvider so it works outside SalesModal.
 */
const CommercialDateTimePicker: React.FC<CommercialDateTimePickerProps> = ({
  label,
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
      <Box sx={{ width: '100%' }}>
        <DesktopDateTimePicker
          label={label}
          value={value}
          onChange={(v) => {
            if (v != null && isValid(v)) {
              onChange(v);
            }
          }}
          disabled={disabled}
          disableFuture
          views={['year', 'month', 'day', 'hours', 'minutes']}
          ampm={false}
          format="dd/MM/yyyy HH:mm"
          timeSteps={{ minutes: 1 }}
          slotProps={{
            textField: {
              size: 'small',
              fullWidth: true,
              placeholder: 'dd/mm/aaaa hh:mm',
              helperText:
                'Seleccione fecha y hora en el calendario o escríbalas. No puede ser en el futuro.',
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CommercialDateTimePicker;
